(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-products"] && !Shopify.designMode) return;
  try {
    
// SPEC-045: client-side product-type filtering. No state persisted — every page
// load starts on "All". Filters only the cards already rendered in the grid.
(function () {
  var chips = document.querySelectorAll('.tp__chip');
  var cards = document.querySelectorAll('.tp__card-wrap[data-type]');
  if (!chips.length) return;

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) { c.classList.remove('tp__chip--active'); });
      chip.classList.add('tp__chip--active');

      var filter = chip.dataset.filter;
      cards.forEach(function (card) {
        card.style.display = (filter === 'all' || card.dataset.type === filter) ? '' : 'none';
      });
    });
  });
})();

document.querySelectorAll('.js-qa-btn').forEach(function(btn) {
  btn.addEventListener('click', async function(e) {
    e.preventDefault();
    e.stopPropagation();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (res.ok) {
        var icon = btn.querySelector('.material-symbols-outlined');
        btn.classList.add('qa--success');
        if (icon) icon.textContent = 'check';
        setTimeout(function() {
          btn.classList.remove('qa--success');
          if (icon) icon.textContent = 'add';
          btn.disabled = false;
        }, 1800);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } else {
        btn.disabled = false;
      }
    } catch (err) {
      btn.disabled = false;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-support"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.js-share-btn').forEach(function(btn) {
  btn.addEventListener('click', async function() {
    var url   = btn.dataset.url;
    var title = btn.dataset.title;
    var originalText = btn.innerHTML;
    if (navigator.share) {
      try {
        await navigator.share({ title: title, url: url });
      } catch (e) {
        // user cancelled — no action needed
      }
    } else {
      try {
        await navigator.clipboard.writeText(url);
        btn.textContent = 'Link copied!';
        setTimeout(function() { btn.innerHTML = originalText; }, 2500);
      } catch (e) {
        // clipboard unavailable — silent fail
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
